export const Random = () => Math.random()
